/**
 * O que é tela da aplicação e o que não é.
 *
 * ## Por que isto precisa existir
 *
 * A plataforma serve **dois tipos de endereço** sob o mesmo domínio: as telas
 * do React, resolvidas pelo roteador no navegador, e o conteúdo publicado
 * pelos usuários, servido pelo Express sem passar pelo pacote do Vite.
 *
 * `navigate()` do `react-router` só alcança o primeiro grupo. Mandá-lo a um
 * endereço do segundo não dá erro: ele troca a URL, não acha rota nenhuma, e a
 * aplicação desenha a própria tela de "não encontrada" — **sobre um endereço
 * que existe e abre normalmente** se for carregado de verdade.
 *
 * Foi o que aconteceu em 21/10: o aviso de "fulano compartilhou um artefato
 * com você" levava a `/pagina-<uuid>`, e clicar nele dizia que a página não
 * existia. Abrir o mesmo artefato pela lista funcionava, porque lá o cartão é
 * um `<a href>` de verdade.
 *
 * ## O prefixo é um invariante da plataforma, não um palpite
 *
 * Todo conteúdo publicado mora em `pagina-<32 hexadecimais>`, e **nenhuma rota
 * da aplicação pode começar assim** — há teste no backend que reprova se
 * alguém criar uma. Ver `PREFIXO` em `backend/src/db/sites.js`.
 */

/** O espaço de nomes do conteúdo publicado. Espelha `PREFIXO` do backend. */
export const PREFIXO_CONTEUDO = 'pagina-';

/**
 * Este caminho é conteúdo publicado, servido fora do roteador?
 *
 * @param {string} caminho um caminho relativo, como `/pagina-abc` ou `/admin`
 */
export function ehConteudoPublicado(caminho) {
  return String(caminho ?? '').startsWith(`/${PREFIXO_CONTEUDO}`);
}

export default { PREFIXO_CONTEUDO, ehConteudoPublicado };
